import React from "react";
import { ProBadge } from "../pro-badge";

export const MeetingReliefBadge = (): JSX.Element => {
  return <ProBadge className="cw-ml-2 cw-text-positive cw-bg-positive" />;
};
